/**
 * Короткое сообщение поверх экрана — «Заполнено по голосу», «Имя сохранено»
 * (28.10.2026).
 *
 * Раньше такие подтверждения оставались строкой в форме и после того, как
 * их прочитали, занимали место и мешали. Теперь — плашкой вверху экрана:
 * сама уходит через пару секунд, тап убирает сразу. Вверху — чтобы не
 * закрывать клавиатуру и кнопку записи. Новое сообщение сменяет прежнее.
 *
 * Только для подтверждений, которые достаточно увидеть. Объяснение, которое
 * нужно прочитать, или решение, которое человек принял, остаётся на экране.
 */
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from './icon.js';

/** Сколько видна плашка. */
const SHOW_MS = 2600;

type Message = { id: number; text: string };
let show: ((m: Message) => void) | null = null;
let seq = 0;

/** Показать подтверждение. Без `FlashHost` на странице — ничего не делает. */
export function flash(text: string): void {
  show?.({ id: ++seq, text });
}

/** Место для плашки: один раз в корне приложения. */
export function FlashHost() {
  const [message, setMessage] = useState<Message | null>(null);
  useEffect(() => {
    show = setMessage;
    return () => { if (show === setMessage) show = null; };
  }, []);
  useEffect(() => {
    if (!message) return;
    const t = window.setTimeout(() => setMessage(null), SHOW_MS);
    return () => window.clearTimeout(t);
  }, [message]);
  if (!message || typeof document === 'undefined') return null;
  return createPortal(
    <div key={message.id} className="flashmsg" role="status" onClick={() => setMessage(null)}>
      <Icon name="check" size={14} /><span>{message.text}</span>
    </div>,
    document.body,
  );
}
